// login & logout
export const LOAD_LOGGED_USER_SUCCESS = 'LOAD_LOGGED_USER_SUCCESS';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER'

// user list
export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

// training list

export const LOAD_SINGLE_TRAINING_SUCCESS = 'LOAD_SINGLE_TRAINING_SUCCESS';
export const LOAD_TRAININGS_SUCCESS = 'LOAD_TRAININGS_SUCCESS';
export const ADD_TRAINING_SUCCESS = 'ADD_TRAINING_SUCCESS';
export const UPDATE_TRAINING_SUCCESS = 'UPDATE_TRAINING_SUCCESS';
export const SAVE_TRAINING_SUCCESS = 'SAVE_TRAINING_SUCCESS';
export const DELETE_TRAINING_SUCCESS = 'DELETE_USER_SUCCESS';

// training weekly summaries
export const LOAD_WEEKLY_SUMMARIES_SUCCESS = "LOAD_WEEKLY_SUMMARIES_SUCCESS";
export const LOAD_WEEKLY_SUMMARIES_ERROR = "LOAD_WEEKLY_SUMMARIES_ERROR";

// Training Periods
export const LOAD_TRAINING_PERIODS_SUCCESS = "LOAD_TRAINING_PERIODS_SUCCESS";
export const LOAD_SINGLE_TRAINING_PERIOD_SUCCESS = "LOAD_SINGLE_TRAINING_PERIOD_SUCCESS";
export const ADD_TRAINING_PERIOD_SUCCESS = "ADD_TRAINING_PERIOD_SUCCESS";
export const UPDATE_TRAINING_PERIOD_SUCCESS = "UPDATE_TRAINING_PERIOD_SUCCESS";
export const DELETE_TRAINING_PERIOD_SUCCESS = "DELETE_TRAINING_PERIOD_SUCCESS";